import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Eye, EyeOff } from 'lucide-react';
import { StyledForm, StyledInput, SubmitButton, ErrorMessage, StyledImage, StyledComment, InputWrapper, EyeStyled, SuccessMessageWrapper, SuccessMessage } from '../styled';
import { BASE_URL } from '../../../environment/environment';
import logo from '../../../images/logo.png';
import { CheckCircle } from 'lucide-react';

export const RegisterForm = ({ email }) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [companyPosition, setCompanyPosition] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    setSuccessMessage('');

    try {
      const response = await axios.post(`${BASE_URL}/Auth/register`, { email, password, name, lastName, phoneNumber, companyPosition }, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status === 200) {
        setSuccessMessage('Twoja prośba o dostęp została pomyślnie przesłana, po aktywacji konta uzyskasz dostęp do danych.');
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
      else {
        setError(response.data.message || 'Błąd rejestracji');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Wystąpił błąd.. Użytkownik już posiada ustawione hasło');
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    {successMessage ? (
      <SuccessMessageWrapper>
        <CheckCircle size={30} />
        <SuccessMessage>{successMessage}</SuccessMessage>
      </SuccessMessageWrapper>
    ) : (
      <StyledForm onSubmit={handleRegister}>
        <StyledImage src={logo} alt="Logo" />
        <StyledComment>Zgłoś prośbę o dostęp:</StyledComment>
        <StyledInput type="email" placeholder="E-mail" value={email} required disabled />
        <StyledInput type="text" placeholder="Imię" value={name} onChange={(e) => setName(e.target.value)} required disabled={loading} />
        <StyledInput type="text" placeholder="Nazwisko" value={lastName} onChange={(e) => setLastName(e.target.value)} required disabled={loading} />
        <StyledInput type="text" placeholder="Numer telefonu" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} required disabled={loading} />
        <StyledInput type="text" placeholder="Stanowisko w firmie" value={companyPosition} onChange={(e) => setCompanyPosition(e.target.value)} required disabled={loading} />
        <InputWrapper>
          <StyledInput
            type={showPassword ? 'text' : 'password'}
            placeholder="Hasło"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
          <EyeStyled onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </EyeStyled>
        </InputWrapper>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <SubmitButton type="submit" disabled={loading || !email || !password}>
          {loading ? 'Rejestracja...' : 'Zarejestruj się'}
        </SubmitButton>
      </StyledForm>
    )}
    </>
  );
};